import { render } from "./OrderPage.vue?vue&type=template&id=48f76202&scoped=true"
import script from "@/assets/js/order?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/order?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/order.css?vue&type=style&index=0&id=48f76202&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f76202"]])

export default __exports__